<template>
  <div class="teach-data">
    <div class="title">
      <img
        src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202103/d245719943d14fbf88adf94ed6c28ef7.png"
        alt=""
        srcset=""
      />
    </div>
    <div class="data-card-list">
      <div
        class="data-card"
        v-for="({ title, count, icon, link }, i) in dataList"
        :key="i"
      >
        <a target="_blank" :href="link">
        <div class="icon-wrapper">
          <i class="iconfont" :class="icon"></i>
        </div>
        <div class="content">
          <div class="count">{{ count }}</div>
          <div class="text">{{ title }}</div>
        </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.getTeachData();
  },
  data() {
    return {
      teachData: {},
    };
  },
  methods: {
    async getTeachData() {
      const teachData = await this.$http.getTeachData();
      this.teachData = teachData;
    },
  },
  computed: {
    dataList() {
      return [
        {
          title: "本科专业",
          // count: this.teachData.undergraduateMajor,
          count: 59,
          link: 'http://ugs.hrbeu.edu.cn/2819/list.htm',
          icon: "iconbenkezhuanye",
        },
        {
          title: "一流专业",
          // count: this.teachData.firstMajor,
          count: 11,
          link: 'http://xxgk.hrbeu.edu.cn/_upload/article/files/5c/c0/721a4e0445c3ba3caf384e0f0283/81a77e10-a47c-4840-a5cd-f93471ecc688.pdf',
          icon: "iconzhuanrenjiaoshi",
        },
        {
          title: "专任教师",
          // count: this.teachData.fullTimeTeacher,
          count: 1057,
          link: 'http://www.hrbeu.edu.cn/szdw/szjs.aspx',
          icon: "iconzhuanrenjiaoshi",
        },
        {
          title: "教学名师",
          // count: this.teachData.famousTeachers,
          count: 26,
          link: 'http://www.hrbeu.edu.cn/szdw/jxms.aspx',
          icon: "iconjiaoxuemingshi",
        },
        {
          title: "培养方案",
          // count: this.teachData.trainingProgram,
          count: 37,
          link: 'https://dzzy.zhihuishu.com/hrbeu/homeController/queryTrainingView',
          icon: "iconpeiyangfangan",
        },
        {
          title: "一流课程",
          // count: this.teachData.firstClassCourses,
          count: 25,
          link: 'http://jyt.hlj.gov.cn/jyzx/xx/202012/t20201210_157230.htm',
          icon: "iconyiliukecheng",
        },
        {
          title: "教学成果",
          // count: this.teachData.teachingAchievements,
          count: 64,
          link: 'http://ugs.hrbeu.edu.cn/2017/0615/c2822a132698/page.htm',
          icon: "iconjiaoxuechengguo",
        },
        {
          title: "精品MOOC",
          // count: this.teachData.boutiqueMooc,
          count: 6,
          link: 'http://jyt.hlj.gov.cn/jyzx/xx/201910/t20191014_141384.htm',
          icon: "iconjingpinMOOC",
        },
      ];
    },
  },
};
</script>